import { QAPairCheckButton } from './QAPairCheckButton';

export const BuyerCheckButton = (props: {
  checked?: boolean;
  disabledInfo: {
    disabled: boolean;
    tooltip?: string;
  };
}) => {
  const { checked, disabledInfo } = props;

  return (
    <QAPairCheckButton
      color="blue"
      checked={checked}
      disabled={disabledInfo.disabled}
      disabledTooltip={disabledInfo.tooltip}
    />
  );
};
